export default __webpack_public_path__ + "static/N0010-08e7ed1d2661bd5ceb24dc0505f5849a.png";